import React from 'react';
import styled from 'styled-components';

const GalleryWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    @supports (display: grid) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      grid-gap: 1rem;
    }
`;

const PatternGalleryItems = ( items, ref ) =>
    <div ref={ref}>
        <GalleryWrapper>
            {items}
        </GalleryWrapper>
    </div>;

export default PatternGalleryItems;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleryItems.js